<template>
  <div>
    <form enctype="multipart/form-data" v-if="!issuccess">
      <h2 class="head">Bewerbung zum Veltins-Lokalsportpreis 2025</h2>
      <div class="form-group" :class="{ 'has-error': !!errors.anrede }">
        <div class="input-group">
          <select
            type="text"
            class="form-control"
            v-model="data.anrede"
            id="data_anrede"
          >
            <option value="">Bitte wählen</option>
            <option value="Herr">Herr</option>
            <option value="Frau">Frau</option>
          </select>
          <label class="col-form-label" for="data_anrede">Anrede</label>
        </div>
        <div class="invalid-feedback">{{ errors.anrede }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.vorname }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.vorname"
            id="data_vorname"
          /><label class="col-form-label" for="data_vorname">Vorname</label>
        </div>
        <div class="invalid-feedback">{{ errors.vorname }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.nachname }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.nachname"
            id="data_nachname"
          /><label class="col-form-label" for="data_nachname">Nachname</label>
        </div>
        <div class="invalid-feedback">{{ errors.nachname }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.funktion }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.funktion"
            id="data_funktion"
          /><label class="col-form-label" for="data_funktion">Funktion</label>
        </div>
        <div class="invalid-feedback">{{ errors.funktion }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.verlag }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.verlag"
            id="data_verlag"
          /><label class="col-form-label" for="data_verlag">Verlag</label>
        </div>
        <div class="invalid-feedback">{{ errors.verlag }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.zeitung }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.zeitung"
            id="data_zeitung"
          /><label class="col-form-label" for="data_zeitung">Zeitung</label>
        </div>
        <div class="invalid-feedback">{{ errors.zeitung }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.strasse }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.strasse"
            id="data_strasse"
          /><label class="col-form-label" for="data_strasse">Straße</label>
        </div>
        <div class="invalid-feedback">{{ errors.strasse }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.plz_ort }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.plz_ort"
            id="data_plz_ort"
          /><label class="col-form-label" for="data_plz_ort">PLZ/Ort</label>
        </div>
        <div class="invalid-feedback">{{ errors.plz_ort }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.email }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.email"
            id="data_email"
          /><label class="col-form-label" for="data_email">E-Mail</label>
        </div>
        <div class="invalid-feedback">{{ errors.email }}</div>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.telefon }">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            v-model="data.telefon"
            id="data_telefon"
          /><label class="col-form-label" for="data_telefon">Telefon</label>
        </div>
        <div class="invalid-feedback">{{ errors.telefon }}</div>
      </div>

      <fieldset
        class="form-group"
        :class="{ 'has-error': !!errors.arbeitsverhaeltniss }"
      >
        <div class="row">
          <legend class="col-form-label">Arbeitsverhältniss</legend>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="arbeitsverhaeltniss"
              id="arbeitsverhaeltniss1"
              :value="ARBEITSVERHAELTNISS.FREIERMITARBEITER"
              v-model="data.arbeitsverhaeltniss"
            />
            <label class="form-check-label" for="arbeitsverhaeltniss1">
              freie Mitarbeit
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="arbeitsverhaeltniss"
              id="arbeitsverhaeltniss2"
              :value="ARBEITSVERHAELTNISS.FESTANGESTELLT"
              v-model="data.arbeitsverhaeltniss"
            />
            <label class="form-check-label" for="arbeitsverhaeltniss2">
              Festanstellung
            </label>
          </div>
        </div>
        <div class="invalid-feedback">{{ errors.arbeitsverhaeltniss }}</div>
      </fieldset>

      <fieldset
        class="form-group"
        :class="{ 'has-error': !!errors.einreichungtyp }"
      >
        <div class="row">
          <legend class="col-form-label">Art der Einreichung</legend>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="einreichungtyp"
              id="einreichungtyp1"
              :value="EINREICHUNGTYP.WORT"
              v-model="data.einreichungtyp"
            />
            <label class="form-check-label" for="einreichungtyp1">
              Wort
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="einreichungtyp"
              id="einreichungtyp2"
              :value="EINREICHUNGTYP.BILD"
              v-model="data.einreichungtyp"
            />
            <label class="form-check-label" for="einreichungtyp2">
              Bild
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="einreichungtyp"
              id="einreichungtyp3"
              :value="EINREICHUNGTYP.ONLINE"
              v-model="data.einreichungtyp"
            />
            <label class="form-check-label" for="einreichungtyp3">
              Online
            </label>
          </div>
        </div>
        <div class="invalid-feedback">{{ errors.einreichungtyp }}</div>
      </fieldset>
      <fieldset class="einreichungen">
        <div
          v-for="(artikel, index) in data.artikel"
          v-bind:key="index"
          class="artikel-liste"
        >
          <div class="index">Beitrag {{ index + 1 }}</div>
          <div class="artikel">
            <div
              class="form-group"
              :class="{
                'has-error':
                  errors.artikel[index] && !!errors.artikel[index].ueberschrift,
              }"
            >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  v-model="artikel.ueberschrift"
                  :id="'artikel.ueberschrift.' + index"
                /><label
                  :for="'artikel.ueberschrift.' + index"
                  class="col-form-label"
                  >Überschrift</label
                >
              </div>
              <div class="invalid-feedback" v-if="errors.artikel[index]">
                {{ errors.artikel[index].ueberschrift }}
              </div>
            </div>
            <div
              class="form-group"
              :class="{
                'has-error':
                  errors.artikel[index] &&
                  !!errors.artikel[index].erscheinungsdatum,
              }"
            >
              <div class="input-group">
                <input
                  type="date"
                  :min="ERSCHEINUNGSDATUM_MIN"
                  :max="ERSCHEINUNGSDATUM_MAX"
                  pattern="\d{2}-\d{2}-\d{4}"
                  class="form-control"
                  v-model="artikel.erscheinungsdatum"
                  :id="'artikel.erscheinungsdatum.' + index"
                /><label
                  :for="'artikel.erscheinungsdatum.' + index"
                  class="col-form-label"
                  >Erscheinungsdatum</label
                >
              </div>
              <div class="invalid-feedback" v-if="errors.artikel[index]">
                {{ errors.artikel[index].erscheinungsdatum }}
              </div>
            </div>
            <div
              class="form-group"
              :class="{
                'has-error':
                  errors.artikel[index] && !!errors.artikel[index].beschreibung,
              }"
            >
              <div class="input-group">
                <textarea
                  class="form-control"
                  v-model="artikel.beschreibung"
                  :id="'artikel.beschreibung.' + index"
                  rows="5"
                ></textarea
                ><label
                  :for="'artikel.beschreibung.' + index"
                  class="col-form-label"
                  >Beschreibung</label
                >
              </div>
              <div class="invalid-feedback" v-if="errors.artikel[index]">
                {{ errors.artikel[index].beschreibung }}
              </div>
            </div>
            <div
              class="form-group"
              :class="{
                'has-error':
                  errors.artikel[index] && !!errors.artikel[index].datei,
              }"
            >
              <div class="input-group">
                <input
                  type="file"
                  class="form-control file-upload"
                  :name="'artikel.datei.' + index"
                  @change="handleFileUpload(index, $event.target.files)"
                  accept="application/pdf"
                />
                <label :for="'artikel.datei.' + index" class="col-form-label"
                  >Datei</label
                >
              </div>
              <small class="form-text text-muted"
                >Bitte nur PDF Dateien auswählen. (max
                {{ MAX_FILESIZE_IN_MB }} MB)
              </small>
              <div class="invalid-feedback" v-if="errors.artikel[index]">
                {{ errors.artikel[index].datei }}
              </div>
            </div>
            <div class="invalid-feedback" v-if="errors.artikel[index]">
              {{ errors.artikel[index].artikel }}
            </div>
            <button
              v-on:click.prevent="removeArtikel(index)"
              class="btn-vue btn-delete"
              v-if="index > 0"
              type="button"
            >
              - Artikel löschen
            </button>
          </div>
        </div>
        <button
          v-on:click.prevent="addArtikel"
          v-if="this.data.artikel.length < this.MAX_ANZHAL_BEITRAEGE"
          type="button"
          class="btn-vue btn-add"
        >
          + weiteren Artikel hinzufügen
        </button>
      </fieldset>
      <fieldset
        class="form-group"
        :class="{ 'has-error': !!errors.aufmerksam }"
      >
        <div class="row">
          <legend class="col-form-label ">
            Wie sind Sie auf den VLSP aufmerksam geworden?
          </legend>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="aufmerksam"
              id="aufmerksam1"
              :value="AUFMERKSAM.INTERNET"
              v-model="data.aufmerksam.typ"
            />
            <label class="form-check-label" for="aufmerksam1">
              Internet
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="aufmerksam"
              id="aufmerksam2"
              :value="AUFMERKSAM.ANZEIGE"
              v-model="data.aufmerksam.typ"
            />
            <label class="form-check-label" for="aufmerksam2">
              Anzeige
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="aufmerksam"
              id="aufmerksam3"
              :value="AUFMERKSAM.VERLAG"
              v-model="data.aufmerksam.typ"
            />
            <label class="form-check-label" for="aufmerksam3">
              Verlag
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="aufmerksam"
              id="aufmerksam4"
              :value="AUFMERKSAM.SONSTIGES"
              v-model="data.aufmerksam.typ"
            />
            <label class="form-check-label" for="aufmerksam4">
              Sonstiges
            </label>
          </div>
        </div>
        <div
          class="form-group"
          v-if="this.data.aufmerksam.typ == this.AUFMERKSAM.SONSTIGES"
        >
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              v-model="data.aufmerksam.freitext"
              id="aufmerksam4.1"
            />
            <label for="aufmerksam4.1" class="col-form-label "
              >Bitte angeben</label
            >
          </div>
        </div>
        <div class="invalid-feedback">
          {{ errors.aufmerksam }}
        </div>
      </fieldset>
      <div class="">
        <p><b>Teilnahmebedingungen:</b></p>
        <ol class="tnb-list">
          <li>
            Der Wettbewerb ist offen für Mitarbeiterinnen und Mitarbeiter
            lokaler und regionaler Tageszeitungen.
          </li>
          <li>
            Die Beiträge müssen zwischen dem 1. Januar 2024 und dem 31. Dezember
            2024 veröffentlicht worden sein.
          </li>
          <li>
            Pro Einsender können bis zu drei Beiträge eingereicht werden (in den
            Kategorien Wort, Bild und Online). Beiträge können auch über Dritte
            eingereicht werden.
          </li>
          <li>
            Die Teilnehmer am VELTINS-LOKALSPORTPREIS 2025 geben ihre
            Einwilligung zur Veröffentlichung und Ausstellung der ausgewählten
            Beiträge im Rahmen einer Publikation des Verbandes Deutscher
            Lokalzeitungen und Lokalmedien (VDL), auch in verändertem Format.
            Honoraransprüche können hierfür nicht geltend gemacht werden.
          </li>
          <li>
            Die Einsendung der Beiträge/Fotos muss digital über das Online-
            Bewerbungsformular unter www.lokalsportpreis.de erfolgen. Die
            Artikel und Fotos werden zusätzlich als Zeitungsseitenansicht bzw.
            Screenshot der Webseite im PDF-Format benötigt. Bitte laden Sie Ihre
            kompletten Unterlagen in einer Datei mit dem vollständig
            ausgefüllten Online-Anmelde-Formular und der Online-Zustimmung
            (Einverständniserklärung) hoch.
          </li>
          <li>
            Eingereichte Texte, Beiträge und Bilder dürfen nicht durch KI bzw.
            KI-Unterstützung generiert worden sein.
          </li>
          <li>
            Es werden nur vollständige Unterlagen in die Bewertung aufgenommen.
          </li>
          <li>Der Rechtsweg ist ausgeschlossen.</li>
          <li><b>Einsendeschluss ist der 28. Februar 2025.</b></li>
        </ol>
        <p><b>Video-, Bild- und Tonaufnahmen</b></p>
        <p>
          Der Verband Deutscher Lokalzeitungen e.{{ "\xa0" }}V. und die Brauerei
          Veltins sind Veranstalter des Kongress Deutscher Lokalzeitungen e.{{
            "\xa0"
          }}V. beziehungsweise der Preisverleihung des Veltins-Lokalsportpreis,
          bei der Foto- und Filmmaterialien angefertigt werden.
        </p>
        <p>
          Der VDL, die LZS und die Brauerei Veltins verwenden die Materialien im
          Rahmen ihrer Berichterstattung über die Veranstaltung für ihre Presse-
          und Öffentlichkeitsarbeit, insbesondere in den solzialen Netzwerken,
          auf den Webseiten des VDL, der LZS und der Brauerei Veltins. Die
          Einsendungen werden auch in sonstigen Verbandsmedien zu
          Dokumentationszwecken verwendet. Ferner können die Beiträge/Fotos für
          die Öffentlichkeitsarbeit des VDL, der LZS und der Brauerei Veltins an
          andere Medien weitergegeben werden.
        </p>
        <p>
          <b
            >Sofern Sie mit diesem Passus <u>nicht</u> einverstanden sind,
            vermerken Sie dies bitte auf dem Anmeldebogen.</b
          >
        </p>
        <p>
          Die bei uns gespeicherten Daten werden gelöscht, sobald sie für ihre
          Zweckbestimmung nicht mehr erforderlich sind und der Löschung keine
          gesetzlichen Aufbewahrungspflichten entgegenstehen.
        </p>
      </div>
      <div class="form-group" :class="{ 'has-error': !!errors.tnb }">
        <div class="form-check form-check-feedback">
          <input
            class="form-check-input"
            type="checkbox"
            id="tnbCheck"
            v-model="data.tnb"
          />
          <label class="form-check-label" for="tnbCheck">
            Mit dem Absenden des Formulars stimme ich den Teilnahmebedingungen
            zu.
          </label>
        </div>
        <div class="invalid-feedback">
          {{ errors.tnb }}
        </div>
      </div>
      <div
        class="form-group form-bemerkungen"
        :class="{
          'has-error': !!errors.bemerkung,
        }"
      >
        <div class="input-group">
          <textarea
            class="form-control"
            v-model="data.bemerkung"
            id="bemerkung"
            rows="5"
          ></textarea
          ><label for="bemerkung" class="col-form-label"
            >Bemerkung<br /><small>optional</small></label
          >
        </div>
        <div class="invalid-feedback" v-if="errors.bemerkung">
          {{ errors.bemerkung }}
        </div>
      </div>
      <div class="form-group form-submit-progress">
        <div class="progress">
          <div
            class="progress-bar"
            :style="{ width: uploadPercentCompleted + '%' }"
            v-if="uploadPercentCompleted"
          >
            {{ uploadPercentCompleted }}%
          </div>
        </div>
        <div class="input-group-submit">
          <button
            class="btn-vue btn-submit"
            type="submit"
            v-on:click.prevent="submit()"
          >
            Absenden
          </button>
        </div>
        <div class="invalid-feedback"></div>
      </div>
    </form>
    <div v-else>
      <p>
        <span class="head"
          >Herzlichen Dank für Ihre Bewerbung zum Veltins-Lokalsportpreis
          2025.</span
        ><br />
        <br />
        <span class="copy" x-ms-format-detection="none"
          >Wir haben Ihre Unterlagen erhalten.<br /><br />
          In Kürze erhalten Sie eine Bestätigungsmail mit Hinweisen zum weiteren
          Ablauf des Veltins-Lokalsportpreises.<br /><br />
          Bei Rückfragen erreichen Sie den Verband Deutscher Lokalzeitungen
          e.V., Berlin, telefonisch unter 030/398051-67 oder per Mail
          <a href="mailto:daniela.braun@lokalpresse.de"
            >daniela.braun@lokalpresse.de</a
          >.
        </span>
      </p>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import axios from "axios";

  const ARBEITSVERHAELTNISS_FESTANGESTELLT = "festangestellt";
  const ARBEITSVERHAELTNISS_FREIERMITARBEITER = "freiermitarbeiter";

  const EINREICHUNGTYP_WORT = "wort";
  const EINREICHUNGTYP_BILD = "bild";
  const EINREICHUNGTYP_ONLINE = "online";

  const AUFMERKSAM_INTERNET = "internet";
  const AUFMERKSAM_ANZEIGE = "anzeige";
  const AUFMERKSAM_VERLAG = "verlag";
  const AUFMERKSAM_SONSTIGES = "sonstiges";

  const INIT_ANZHAL_BEITRAEGE = 1;
  const MAX_ANZHAL_BEITRAEGE = 3;

  const MAX_FILESIZE_IN_MB = 8; //mega byte

  const BEITRAGS_JAHR = "2024";

  export default {
    name: "Anmeldebogen",
    props: {
      msg: String,
    },
    created() {
      this.ARBEITSVERHAELTNISS = {
        FESTANGESTELLT: ARBEITSVERHAELTNISS_FESTANGESTELLT,
        FREIERMITARBEITER: ARBEITSVERHAELTNISS_FREIERMITARBEITER,
      };
      this.EINREICHUNGTYP = {
        WORT: EINREICHUNGTYP_WORT,
        BILD: EINREICHUNGTYP_BILD,
        ONLINE: EINREICHUNGTYP_ONLINE,
      };
      this.AUFMERKSAM = {
        INTERNET: AUFMERKSAM_INTERNET,
        ANZEIGE: AUFMERKSAM_ANZEIGE,
        VERLAG: AUFMERKSAM_VERLAG,
        SONSTIGES: AUFMERKSAM_SONSTIGES,
      };
      this.MAX_ANZHAL_BEITRAEGE = MAX_ANZHAL_BEITRAEGE;
      for (let i = this.data.artikel.length; i < INIT_ANZHAL_BEITRAEGE; i++) {
        this.addArtikel();
      }
      this.MAX_FILESIZE_IN_MB = MAX_FILESIZE_IN_MB;

      this.ERSCHEINUNGSDATUM_MIN = BEITRAGS_JAHR + "-01-01";
      this.ERSCHEINUNGSDATUM_MAX = BEITRAGS_JAHR + "-12-31";
    },
    data: function() {
      return {
        artikel: {
          ueberschrift: "",
          erscheinungsdatum: "",
          beschreibung: "",
          datei: null,
        },
        data: {
          anrede: "",
          vorname: "",
          nachname: "",
          funktion: "",
          verlag: "",
          zeitung: "",
          strasse: "",
          plz_ort: "",
          email: "",
          telefon: "",
          arbeitsverhaeltniss: null,
          // arbeitsverhaeltniss: ARBEITSVERHAELTNISS_FESTANGESTELLT,
          einreichungtyp: null,
          // einreichungtyp: EINREICHUNGTYP_BILD,
          artikel: [],
          // artikel: [
          //   {
          //     ueberschrift: "test",
          //     erscheinungsdatum: "01.10.2010",
          //     beschreibung: "test",
          //     datei: null
          //   }
          // ],
          aufmerksam: {
            typ: null,
            freitext: "",
          },
          // aufmerksam: {
          //   typ: AUFMERKSAM_VERLAG,
          //   freitext: ""
          // },
          tnb: false,
          // tnb: true
        },
        errors: {
          artikel: [],
        },
        haserror: false,
        issuccess: false,
        uploadPercentCompleted: 0,
      };
    },
    methods: {
      addArtikel: function() {
        if (this.data.artikel.length < MAX_ANZHAL_BEITRAEGE) {
          this.data.artikel.push(Vue.util.extend({}, this.artikel));
        }
      },
      removeArtikel: function(index) {
        Vue.delete(this.data.artikel, index);
      },
      handleFileUpload(artikelIndex, fileList) {
        this.data.artikel[artikelIndex].datei = fileList[0];
      },
      checkForm() {
        // Leere das Error Objekt
        this.$set(this, "errors", { artikel: [] });
        this.haserror = false;

        let required = [
          "anrede",
          "vorname",
          "nachname",
          "funktion",
          "verlag",
          "zeitung",
          "strasse",
          "plz_ort",
          "email",
          "telefon",
          "arbeitsverhaeltniss",
          "einreichungtyp",
          "aufmerksam",
          "tnb",
        ];
        for (let field of required) {
          if (!this.data[field]) {
            this.$set(this.errors, field, "Bitte geben Sie dieses Feld an!");
            this.haserror = true;
          }
        }
        // if (Object.keys(this.data.artikel).length > 0) {
        // }
        let artikel_error = this.errors.artikel;
        for (let index in this.data.artikel) {
          if (!this.data.artikel[index].datei) {
            artikel_error[index] = { datei: "Bitte geben Sie eine Datei an!" };
            this.haserror = true;
            continue;
          }
          if (
            MAX_FILESIZE_IN_MB <
            this.data.artikel[index].datei.size / 1024 / 1024
          ) {
            artikel_error[index] = {
              datei:
                "Datei ist zu groß! Bitte maximal eine " +
                MAX_FILESIZE_IN_MB +
                " MB Datei auswählen.",
            };
            this.haserror = true;
          }
          if ("application/pdf" != this.data.artikel[index].datei.type) {
            artikel_error[index] = {
              datei: "Datei ist keine PDF Datei!",
            };
            this.haserror = true;
          }
        }

        this.$set(this.errors, "artikel", artikel_error);
        // for (let artikel of this.data.artikel) {
        //   if (!this.data[field]) {
        //     this.$set(this.errors, field, "Bitte geben Sie dieses Feld an!");
        //     this.haserror = true;
        //   }
        // }
        if (!this.data.aufmerksam.typ) {
          this.$set(
            this.errors,
            "aufmerksam",
            "Bitte geben Sie dieses Feld an!"
          );
          this.haserror = true;
        }
      },
      clearForm() {
        this.data = {
          anrede: "",
          vorname: "",
          nachname: "",
          funktion: "",
          verlag: "",
          zeitung: "",
          strasse: "",
          plz_ort: "",
          email: "",
          telefon: "",
          arbeitsverhaeltniss: null,
          einreichungtyp: null,
          artikel: [],
          aufmerksam: {
            typ: null,
            freitext: "",
          },
          tnb: false,
        };
        // this.$set(this, "data", data);
      },
      success() {
        this.clearForm();
        this.issuccess = true;
      },
      submit: function() {
        let self = this;
        this.checkForm();
        if (this.haserror) {
          return;
        }
        function buildFormData(formData, data, parentKey) {
          if (
            data &&
            typeof data === "object" &&
            !(data instanceof Date) &&
            !(data instanceof File)
          ) {
            Object.keys(data).forEach((key) => {
              buildFormData(
                formData,
                data[key],
                parentKey ? `${parentKey}[${key}]` : key
              );
            });
          } else {
            const value = data == null ? "" : data;

            formData.append(parentKey, value);
          }
        }

        function jsonToFormData(data) {
          const formData = new FormData();

          buildFormData(formData, data);

          return formData;
        }

        // Initialize the form data
        let formData = jsonToFormData(this.data);

        const config = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function(progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            self.uploadPercentCompleted = percentCompleted;
          },
        };

        // Make the request to the POST /single-file URL
        axios
          .post("/single-file.php", formData, config)
          .then(function(data) {
            if ("OK" == data.data.success) {
              self.success(data.data);
            }
          })
          .catch(function(data) {
            const errors = data.response.data.error;
            self.errors = errors;
            self.uploadPercentCompleted = 0;
            alert(
              "Es ist ein Fehler aufgetreten. Bitte kontrollieren Sie Ihre Eingaben!"
            );
          });
      },
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $green: #117f38;
  $error: #e2001a;
  $muted: #4d4d4d;

  h2 {
    font-size: 15px;
    font-weight: bold;
    color: #003333;
    margin: 0 0 40px 0;
  }

  .row {
    display: flex;
    flex-flow: row;
  }

  .text-muted {
    color: $muted;
  }

  .invalid-feedback {
    display: none;
    padding: 5px 0;
    font-size: 0.8em;
  }

  .has-error {
    color: $error;
  }

  .form-group {
    .input-group {
      display: flex;
      flex-direction: row-reverse;
    }

    margin-bottom: 15px;
    font-size: 14px;

    .row {
      align-items: center;

      .form-check {
        margin-left: 10px;
      }
    }

    &.has-error {
      .invalid-feedback {
        display: block;
      }
    }

    .form-text {
      margin: 5px 0;
      display: block;
    }
  }

  label {
    cursor: pointer;
  }

  fieldset {
    padding: 0;
    border: none;
  }

  .col-form-label {
    background: $green;
    padding: 7px;
    color: white;
    font-weight: lighter;
    width: 160px;
  }

  .form-control {
    &,
    &:focus,
    &:active {
      border: 1px solid $green;
      outline: none;
      margin: 0;
    }

    padding: 7px;
    font-size: 1em;
    flex: 1;
  }

  .has-error {
    .col-form-label {
      background-color: $error;
    }

    .form-control {
      border-color: $error;
    }

    .form-check-feedback {
      background-color: $error;
      color: white;
      padding: 5px;
    }
  }

  .einreichungen {
    margin-bottom: 20px;
  }

  .artikel-liste {
    // display: flex;
    // flex-direction: column;
    border-top: 1px solid $green;
    margin-top: 20px;

    &:last-of-type {
      border-bottom: 1px solid $green;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }

    .index {
      font-weight: bold;
      padding: 20px 0;
      font-size: 1.5em;
      opacity: 1;
    }

    .artikel {
      // flex: 1;
      display: flex;
      flex-flow: column;
    }

    .btn-delete {
      margin-left: auto;
    }
  }

  .form-bemerkungen {
    margin-top: 40px;
  }

  .form-submit-progress {
    display: flex;

    .input-group {
      margin-left: auto;
    }

    .progress {
      width: 100%;
      display: flex;
      align-items: center;
    }
  }

  .progress-bar {
    background: $muted;
    color: white;
    font-size: 0.8em;
    text-align: center;
    padding: 2px 0;
  }

  .debug {
    font-family: "Courier New", Courier, monospace;
    // white-space: nowrap;
  }
</style>
